import { useRef } from "react";
import { cn } from "../lib/utils";

interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onClear?: () => void;
  loading?: boolean;
  containerClassName?: string;
}

export function SearchInput({
  value,
  onChange,
  onClear,
  loading = false,
  className,
  containerClassName,
  placeholder = "Search…",
  ...rest
}: SearchInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={cn("search-input-wrap", containerClassName)}>
      <span className="search-icon" aria-hidden="true">
        {loading ? (
          <svg className="search-icon-spin" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        ) : (
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        )}
      </span>
      <input
        ref={inputRef}
        type="search"
        className={cn("search-input", className)}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete="off"
        {...rest}
      />
      {value && !loading && (
        <button
          className="search-clear"
          type="button"
          aria-label="Clear search"
          onClick={() => {
            onClear?.();
            inputRef.current?.focus();
          }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
}
